import "core-js/modules/es6.function.name";
import "core-js/modules/es6.string.sub";
import { loginByUsername, logout, getUserInfo } from '@/api/login';
import { getToken, setToken, removeToken, getDeviceId, setUserIdCookie, removeUserIdCookie } from '@/utils/auth';
var user = {
  state: {
    username: '',
    status: '',
    code: '',
    token: getToken(),
    name: '',
    avatar: '',
    introduction: '',
    sub: '',
    roles: [],
    position: '',
    identificationNumber: '',
    internalOrganization: '',
    customerId: '',
    positionTypeId: '',
    internalOrganizationId: '',
    setting: {
      articlePlatform: []
    }
  },
  mutations: {
    SET_CODE: function SET_CODE(state, code) {
      state.code = code;
    },
    SET_TOKEN: function SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_INTRODUCTION: function SET_INTRODUCTION(state, introduction) {
      state.introduction = introduction;
    },
    SET_SETTING: function SET_SETTING(state, setting) {
      state.setting = setting;
    },
    SET_STATUS: function SET_STATUS(state, status) {
      state.status = status;
    },
    SET_NAME: function SET_NAME(state, name) {
      state.name = name;
    },
    SET_SUB: function SET_SUB(state, sub) {
      state.sub = sub;
    },
    SET_AVATAR: function SET_AVATAR(state, avatar) {
      state.avatar = avatar;
    },
    SET_ROLES: function SET_ROLES(state, roles) {
      state.roles = roles;
    },
    SET_POSITION: function SET_POSITION(state, position) {
      state.position = position;
    },
    SET_CUSTOMER_ID: function SET_CUSTOMER_ID(state, customerId) {
      state.customerId = customerId;
    },
    SET_IDENTIFICATION_NUMBER: function SET_IDENTIFICATION_NUMBER(state, identificationNumber) {
      state.identificationNumber = identificationNumber;
    },
    SET_POSITION_TYPE_ID: function SET_POSITION_TYPE_ID(state, positionTypeId) {
      state.positionTypeId = positionTypeId;
    },
    SET_INTERNAL_ORGANIZATION: function SET_INTERNAL_ORGANIZATION(state, internalOrganization) {
      state.internalOrganization = internalOrganization;
    },
    SET_INTERNAL_ORGANIZATION_ID: function SET_INTERNAL_ORGANIZATION_ID(state, internalOrganizationId) {
      state.internalOrganizationId = internalOrganizationId;
    },
    SET_USERNAME: function SET_USERNAME(state, username) {
      state.username = username;
    }
  },
  actions: {
    LoginByUsername: function LoginByUsername(_ref, loginForm) {
      var commit = _ref.commit;
      loginForm.username = loginForm.username.trim();
      loginForm.deviceId = getDeviceId();
      return new Promise(function (resolve, reject) {
        loginByUsername(loginForm).then(function (response) {
          var data = response.data;
          commit('SET_TOKEN', data.access_token);
          setToken(data.access_token);
          resolve(data);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    GetUserInfo: function GetUserInfo(_ref2) {
      var commit = _ref2.commit,
        state = _ref2.state;
      return new Promise(function (resolve, reject) {
        getUserInfo(state.token).then(function (response) {
          if (!response.data) {
            Promise.Reject('error');
          }
          var data = response.data;
          if (data.role && data.role.length > 0) {
            commit('SET_ROLES', data.role);
          } else {
            Promise.Reject('getInfo: roles must be a non-null array !');
          }
          commit('SET_SUB', data.sub);
          commit('SET_USERNAME', data.unique_name);
          // commit('SET_POSITION', data.main_position_name)
          // commit('SET_CUSTOMER_ID', data.main_position_id)
          // commit('SET_IDENTIFICATION_NUMBER', data.position_type_name)
          // commit('SET_POSITION_TYPE_ID', data.position_type_id)
          // commit('SET_INTERNAL_ORGANIZATION', data.internal_organization_name)
          // commit('SET_INTERNAL_ORGANIZATION_ID', data.internal_organization_id)
          commit('SET_NAME', '');
          commit('SET_CUSTOMER_ID', data.customer_id || '');
          commit('SET_IDENTIFICATION_NUMBER', '');

          // Set UserId cookie dynamically
          setUserIdCookie(data.customer_id);
          // onlineBranchApi.customerDetails()
          //   .then((v) => {
          //     commit('SET_NAME', v.data.name)
          //     commit('SET_CUSTOMER_ID', v.data.customerId)
          //     commit('SET_IDENTIFICATION_NUMBER', v.data.identificationNumber)

          resolve(response);
          //   }).catch((err) => {
          //     reject('getCustomerDetails: Error' + err)
          //   })
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    LogOut: function LogOut(_ref3) {
      var commit = _ref3.commit,
        state = _ref3.state;
      return new Promise(function (resolve, reject) {
        logout(state.token).then(function () {
          commit('SET_TOKEN', '');
          commit('SET_USERNAME', '');
          commit('SET_ROLES', []);
          commit('SET_POSITION', '');
          commit('SET_CUSTOMER_ID', '');
          commit('SET_IDENTIFICATION_NUMBER', '');
          commit('SET_POSITION_TYPE_ID', '');
          commit('SET_INTERNAL_ORGANIZATION', '');
          commit('SET_INTERNAL_ORGANIZATION_ID', '');
          removeToken();
          removeUserIdCookie();
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    FedLogOut: function FedLogOut(_ref4) {
      var commit = _ref4.commit;
      return new Promise(function (resolve) {
        commit('SET_TOKEN', '');
        commit('SET_USERNAME', '');
        commit('SET_ROLES', []);
        commit('SET_POSITION', '');
        commit('SET_CUSTOMER_ID', '');
        commit('SET_IDENTIFICATION_NUMBER', '');
        commit('SET_POSITION_TYPE_ID', '');
        commit('SET_INTERNAL_ORGANIZATION', '');
        commit('SET_INTERNAL_ORGANIZATION_ID', '');
        removeToken();
        removeUserIdCookie();
        resolve();
      });
    },
    ChangeRoles: function ChangeRoles(_ref5, role) {
      var commit = _ref5.commit;
      return new Promise(function (resolve) {
        commit('SET_TOKEN', role);
        setToken(role);
        getUserInfo(role).then(function (response) {
          var data = response.data;
          commit('SET_ROLES', data.role);
          commit('SET_NAME', data.name);
          commit('SET_AVATAR', data.avatar);
          commit('SET_POSITION', data.main_position_name);
          commit('SET_CUSTOMER_ID', data.main_position_id);
          commit('SET_IDENTIFICATION_NUMBER', data.position_type_name);
          commit('SET_POSITION_TYPE_ID', data.position_type_id);
          commit('SET_INTERNAL_ORGANIZATION', data.internal_organization_name);
          commit('SET_INTERNAL_ORGANIZATION_ID', data.internal_organization_id);
          resolve();
        });
      });
    }
  }
};
export default user;